import { render, staticRenderFns } from "./LimitedUser.vue?vue&type=template&id=1e4ffba0&"
import script from "./LimitedUser.vue?vue&type=script&lang=js&"
export * from "./LimitedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports